import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { delay, filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
    selector: '[appNumericValidationDirective]',
    standalone: false
})
export class NumericValidationDirective {
  private lastValue: number | null = null;

  private destroy$ = new Subject<void>();

  @Output() sanitizedChange = new EventEmitter<void>();

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl
  ) {}

  ngOnInit() {
    this.checkForExternalChangeOfNgModel();

    this.lastValue = Number(this.el.nativeElement.value);
  }

  private checkForExternalChangeOfNgModel() {
    this.control.valueChanges?.pipe(
      takeUntil(this.destroy$),
      delay(0),
      map(value => {
        return value ?? 0;
      }),
      filter(value => value !== this.lastValue)
    ).subscribe(value => {
      this.lastValue = value;
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const maxAttr = input.getAttribute('max');
    const max = maxAttr !== null ? Number(maxAttr) : Infinity;

    if (!input.validity.valid || Number(input.value) > max) {
      input.value = '';
    }

    const sanitizedNumber = Number(input.value);

    input.value = sanitizedNumber.toString();

    if (this.control.control) {
      this.control.control.setValue(sanitizedNumber, { emitEvent: false });
    }

    if (sanitizedNumber !== this.lastValue) {
      this.lastValue = sanitizedNumber;
      this.sanitizedChange.emit();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
